import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import propTypes from 'prop-types';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useHistory } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import CircularProgress from '@mui/material/CircularProgress';
import Modal from '@mui/material/Modal';
import useRequest from '../../../Hooks/useRequest';
import { countryCodes, stateCodes, provinceCodes } from '../../../Utils/Consts';

const AddAnAdvertiserContainer = styled.div`
    display: flex;
    height: 800px;
    width: 900px;
    margin-left: auto;
    margin-right: auto;
    flex-direction: column;
`;

const Title = styled.div`
    font-size: 30px;
    margin-bottom: 25px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    height: 50px;
    flex-direction: column;
    font-weight: bold;
    text-align: center;
`;

const RowContainer = styled.div`
    margin-left: auto;
    margin-right: auto;
    display: flex;
    flex-direction: row;
    width: 800px;
    justify-content: space-evenly;
`;
const StyledNavButtons = styled.div`
    display: flex;
    justify-content: space-evenly;
    width: 500px;
    height: 70px;
    margin-left: auto;
    margin-right: auto;
`;

const BackBtn = styled(Button)`
    background: red 0% 0% no-repeat padding-box !important;
    box-shadow: 0px 3px 3px #00000061;
    border-radius: 4px;
    opacity: 1;
    height: 40px;
    color: #fafbf7;
`;

const NextBtn = styled(Button)`
    background: #2e69fe 0% 0% no-repeat padding-box !important;
    box-shadow: 0px 3px 3px #00000061;
    border-radius: 4px;
    opacity: 1;
    height: 40px;
    color: #fafbf7;

    &.MuiButton-contained.Mui-disabled {
        color: #fafbf7;
    }
    :disabled {
        background: #9b9b9d 0% 0% no-repeat padding-box !important;
    }
`;

const StyledTextField = styled(TextField)`
    width: 350px;
`;

const StyledDropdown = styled.div``;

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: 'white',
    width: 1100,
    padding: 23,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

const AddUsersModal = (props) => {
    const { modalIsOpen, postAdvertiser, mutate, profile, handleClose } = props;
    const history = useHistory();

    const initialState = {
        parentAccountId: '',
        companyName: '',
        companyWebsite: '',
        firstName: '',
        lastName: '',
        title: '',
        primaryPhone: '',
        mobilePhone: '',
        streetAddress: '',
        secondaryAddress: '',
        additionalAddress: [],
        advertiserEmail: '',
        city: '',
        state: '',
        country: '',
        zipCode: '',
        planTypeId: '',
        accountType: 'Advertiser',
    };
    const [newAdvertiserData, setNewAdvertiserData] = useState({ ...initialState });

    const [advertiserPostData, setAdvertiserPostData] = useState({
        data: null,
        error: null,
        isLoading: false,
    });

    useEffect(() => {
        setNewAdvertiserData({
            ...newAdvertiserData,
            parentAccountId: profile.parentAccountId,
        });
    }, [profile]);

    const {
        companyName,
        companyWebsite,
        firstName,
        lastName,
        title,
        advertiserEmail,
        primaryPhone,
        mobilePhone,
        parentAccountId,
        streetAddress,
        secondaryAddress,
        additionalAddress,
        city,
        state,
        country,
        zipCode,
        planTypeId,
        accountType,
    } = { ...newAdvertiserData };

    const resetFields = () => {
        setNewAdvertiserData({
            parentAccountId: '',
            companyName: '',
            companyWebsite: '',
            firstName: '',
            lastName: '',
            title: '',
            primaryPhone: '',
            mobilePhone: '',
            streetAddress: '',
            secondaryAddress: '',
            additionalAddress: [],
            advertiserEmail: '',
            city: '',
            state: '',
            country: '',
            zipCode: '',
            planTypeId: '',
            accountType: 'Advertiser',
        });
    };

    const handleCloseModal = () => {
        resetFields();
        handleClose();
    };

    const disableAddButton =
        companyName === '' ||
        firstName === '' ||
        lastName === '' ||
        primaryPhone === '' ||
        mobilePhone === '' ||
        streetAddress === '' ||
        city === '' ||
        state === '' ||
        country === '' ||
        advertiserEmail === '' ||
        zipCode === '';

    const body = (
        <div style={style}>
            <AddAnAdvertiserContainer>
                <Title>Add Users</Title>
                <RowContainer>
                    <StyledTextField
                        id="company-name"
                        label="Company Name"
                        value={companyName}
                        onChange={(e) =>
                            setNewAdvertiserData({
                                ...newAdvertiserData,
                                companyName: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={companyName === ''}
                    />
                    <StyledTextField
                        id="company-website"
                        label="Company Website"
                        value={companyWebsite}
                        onChange={(e) =>
                            setNewAdvertiserData({
                                ...newAdvertiserData,
                                companyWebsite: e.target.value,
                            })
                        }
                        variant="outlined"
                    />
                </RowContainer>
                <br />
                <RowContainer>
                    <StyledTextField
                        id="first-name"
                        label="First Name"
                        value={firstName}
                        onChange={(e) =>
                            setNewAdvertiserData({
                                ...newAdvertiserData,
                                firstName: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={firstName === ''}
                    />
                    <StyledTextField
                        id="last-name"
                        label="Last Name"
                        value={lastName}
                        onChange={(e) =>
                            setNewAdvertiserData({
                                ...newAdvertiserData,
                                lastName: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={lastName === ''}
                    />
                </RowContainer>

                <br />
                <RowContainer>
                    <StyledTextField
                        id="primary-phone"
                        label="Primary Phone"
                        value={primaryPhone}
                        onChange={(e) =>
                            setNewAdvertiserData({
                                ...newAdvertiserData,
                                primaryPhone: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={primaryPhone === ''}
                    />
                    <StyledTextField
                        id="mobile-phone"
                        label="Mobile Phone"
                        value={mobilePhone}
                        onChange={(e) =>
                            setNewAdvertiserData({
                                ...newAdvertiserData,
                                mobilePhone: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={mobilePhone === ''}
                    />
                </RowContainer>
                <br />
                <RowContainer style={{ justifyContent: 'unset', paddingLeft: '33px' }}>
                    <StyledTextField
                        style={{ width: '733px' }}
                        id="title"
                        label="Your Title"
                        value={title}
                        onChange={(e) =>
                            setNewAdvertiserData({
                                ...newAdvertiserData,
                                title: e.target.value,
                            })
                        }
                        variant="outlined"
                    />
                </RowContainer>
                <br />

                <RowContainer style={{ justifyContent: 'unset', paddingLeft: '33px' }}>
                    <StyledTextField
                        style={{ width: '733px' }}
                        id="email-address"
                        label="Advertiser Email"
                        value={advertiserEmail}
                        onChange={(e) =>
                            setNewAdvertiserData({
                                ...newAdvertiserData,
                                advertiserEmail: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={advertiserEmail === ''}
                    />
                </RowContainer>
                <br />
                <RowContainer style={{ justifyContent: 'unset', paddingLeft: '33px' }}>
                    <StyledTextField
                        style={{ width: '733px' }}
                        id="street-address"
                        label="Street Address"
                        value={streetAddress}
                        onChange={(e) =>
                            setNewAdvertiserData({
                                ...newAdvertiserData,
                                streetAddress: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={streetAddress === ''}
                    />
                </RowContainer>
                <br />
                <RowContainer style={{ justifyContent: 'unset', paddingLeft: '33px' }}>
                    <StyledDropdown>
                        <FormControl required error={country === ''} variant="outlined">
                            <InputLabel id="country-dropdown">Country</InputLabel>
                            <Select
                                style={{ marginRight: '15px', width: '240px' }}
                                labelId="country-dropdown"
                                id="country-dropdown"
                                value={country}
                                onChange={(e) =>
                                    setNewAdvertiserData({
                                        ...newAdvertiserData,
                                        country: e.target.value,
                                        state: '',
                                    })
                                }
                                label="country"
                            >
                                {countryCodes.map((item, idx) => (
                                    <MenuItem key={idx} value={item}>
                                        {item}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </StyledDropdown>

                    <StyledTextField
                        style={{ marginRight: '15px', width: '240px' }}
                        id="city"
                        label="City"
                        value={city}
                        onChange={(e) =>
                            setNewAdvertiserData({
                                ...newAdvertiserData,
                                city: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={city === ''}
                    />
                    <StyledDropdown>
                        <FormControl
                            disabled={country === ''}
                            required
                            error={country !== '' && state === ''}
                            variant="outlined"
                        >
                            <InputLabel id="state-or-province">
                                {country === 'USA' ? 'State' : 'Province'}
                            </InputLabel>
                            <Select
                                style={{ marginRight: '15px', width: '120px' }}
                                labelId="state-or-province"
                                id="state-or-province"
                                value={state}
                                onChange={(e) =>
                                    setNewAdvertiserData({
                                        ...newAdvertiserData,
                                        state: e.target.value,
                                    })
                                }
                                label="state"
                            >
                                {country === 'USA'
                                    ? stateCodes.map((item, idx) => (
                                          <MenuItem key={idx} value={item}>
                                              {item}
                                          </MenuItem>
                                      ))
                                    : provinceCodes.map((item, idx) => (
                                          <MenuItem key={idx} value={item}>
                                              {item}
                                          </MenuItem>
                                      ))}
                            </Select>
                        </FormControl>
                    </StyledDropdown>

                    <StyledTextField
                        style={{ width: '90px' }}
                        id="zipcode"
                        label="Zipcode"
                        value={zipCode}
                        onChange={(e) =>
                            setNewAdvertiserData({
                                ...newAdvertiserData,
                                zipCode: e.target.value,
                            })
                        }
                        variant="outlined"
                        required
                        error={zipCode === ''}
                    />
                </RowContainer>

                <br />
                <br />
                <div>{advertiserPostData?.error?.reason}</div>
                <StyledNavButtons>
                    <BackBtn variant="contained" color="primary" onClick={() => handleCloseModal()}>
                        Cancel
                    </BackBtn>
                    <NextBtn
                        variant="contained"
                        color="primary"
                        onClick={() => handleSave()}
                        disabled={disableAddButton}
                    >
                        {advertiserPostData.isLoading ? (
                            <CircularProgress
                                style={{ height: '20px', width: '20px', color: 'white' }}
                                color="primary"
                            />
                        ) : (
                            'Save'
                        )}
                    </NextBtn>
                </StyledNavButtons>
            </AddAnAdvertiserContainer>
        </div>
    );

    return (
        <div>
            <Modal
                open={modalIsOpen}
                onClose={() => handleClose()}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
            >
                {body}
            </Modal>
        </div>
    );
};

AddUsersModal.propTypes = {
    modalIsOpen: propTypes.bool,
    handleClose: propTypes.func,
    advertisers: propTypes.shape({}),
    // setAdvertisers: propTypes.func,
    postAdvertiser: propTypes.func,
    mutate: propTypes.func,
    profile: propTypes.shape({
        parentAccountId: propTypes.string,
        parentAccount: propTypes.shape({}),
    }),
};

AddUsersModal.defaultProps = {
    advertisers: {},
    // setAdvertisers: () => {},
    postAdvertiser: () => {},
    mutate: () => {},
    profile: { parentAccountId: '' },
};
export default AddUsersModal;
